import {isNil} from 'ramda';

import type {Locale} from '@dms/api/base';

import {GroupDefinition} from '../types/Definition';

/**
 * Filters per-authorization-profile template lists inside each definition by locale.
 *
 * Locale-agnostic templates (template.locale == null) are intentionally hidden
 * when a specific locale is active. When `selectedLocale` is null, the
 * definitions are returned unchanged.
 */
export const filterDefinitionsByLocale = (
  definitions: GroupDefinition[],
  selectedLocale: Locale | null
): GroupDefinition[] => {
  if (isNil(selectedLocale)) {
    return definitions;
  }

  return definitions.map((definition) => ({
    ...definition,
    authorizationProfiles: definition.authorizationProfiles.map((profile) => ({
      ...profile,
      templates: profile.templates.filter((template) => template.locale === selectedLocale),
    })),
  }));
};
